<template>
  <div style="height: 100%;
    text-align: left;">
    <el-row>
      <el-col :span="14">
        <h3 style=" display: flex;align-items: center;height: 100%;"><img src="../assets/imgs/logo.png"
               alt="" /> 智能财经报告分析平台</h3>
      </el-col>
      <el-col :span="10"
              style="text-align:right;padding-top: 12px;">

        <el-link v-if="(orgId<0)"
                 :underline=false
                 target="_blank"
                 @click="payDialogVisible=true">
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="../assets/imgs/price.png"
                 alt=""
                 width="15px" /><br>
            会员套餐
          </div>
        </el-link>&nbsp;&nbsp;&nbsp;&nbsp;

        <el-link :underline=false
                 target="_blank"
                 @click="openCustService">
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="../assets/imgs/customer.png"
                 alt=""
                 width="15px" /><br>
            在线客服
          </div>
        </el-link>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link :underline=false
                 target="_blank"
                 @click="openHelp">
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="../assets/imgs/help.png"
                 alt=""
                 width="15px" /><br>
            帮助中心
          </div>
        </el-link>

        <el-link v-if="(orgList && orgList.length >0)"
                 :underline=false
                 target="_blank"
                 @click="changeOrg">
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <em class="iconfont">&#xe611;</em><br />
            切换身份
          </div>
        </el-link>

        &nbsp; &nbsp;
        <el-divider direction="vertical"></el-divider>
        &nbsp;

        <span v-if="userInfo && userInfo.id"
              style=" width: 10px; height: 12px;top: 5px; position: relative;">

          <el-dropdown @command="command">
            <span class="el-dropdown-link">
              <el-avatar :size="20"
                         src="static/img/icon-man.png"></el-avatar>
            </span>
            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item command="user">{{userInfo.name}}</el-dropdown-item>
              <el-dropdown-item command="exit">
                <img src="../assets/imgs/icon-logout.png"
                     alt=""
                     style="position:relative;top:2px" />&nbsp;&nbsp;退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>

        <el-link v-else
                 :underline=false
                 href='https://login.csmar.com:8000/?returnUrl=http://isa.csmar.com/api/web/csmar/loginByToken&appId=50'>
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="static/img/icon-man.png"
                 alt=""
                 width="15px" /><br>
            登录/注册
          </div>
        </el-link>

      </el-col>
    </el-row>

    <!--支付弹出框-->
    <el-dialog class="payContainer"
               :visible.sync="payDialogVisible"
               width="820px"
               center>
      <pay v-if="payDialogVisible"
           :reportId="null" />
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'

import pay from '../components/pay'
export default {
  name: 'HelloWorld',
  props: ['orgList', 'orgId'],
  data () {
    return {
      priceDialogVisible: false,
      modifyPwdDialogVisible: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        repeatPwd: ''
      },

      pricePackage: {},
      payDialogVisible: false,
      qrCodeUrl: '',
      willPay: 0,
      orderTimer: null,
      userInfo: {}

    }
  },
  computed: {
    refreshUserInfo: function () {
      return this.$store.state.refreshUserInfo
    }
  },
  components: {
    pay
  },
  mounted: function () {
    this.getUserInfo()
  },
  watch: {
    pricePackage () {
      let _this = this
      axios.get('/api/web/order/preOrder/' + this.pricePackage).then(resp => {
        _this.willPay = resp.data
      })
    },
    refreshUserInfo () {
      this.getUserInfo()
    },
    orgId () {
      console.log('orgId:' + this.orgId)
    }
  },
  methods: {
    changeOrg () {
      this.$emit('changeOrg')
    },
    openHelp () {
      this.$emit('openHelp')
    },
    getUserInfo () {
      let _this = this
      let temp = JSON.parse(localStorage.getItem('userinfo') || '{}')

      if (temp && temp.id) {
        this.userInfo = temp
      } else {
        this.axios.get('/api/web/auth/userInfo').then(resp => {
          if (resp.data && resp.data.id) {
            _this.userInfo = resp.data
            localStorage.setItem('userinfo', JSON.stringify(_this.userInfo))
          }
        })
      }
    },
    command (v) {
      if (v === 'exit') {
        this.axios.get('/api/web/auth/logout').then(resp => {
          localStorage.setItem('userinfo', '{}')
          window.location.reload()
          // window.location.href = 'about:blank'
          // window.opener = null
          // window.open('', '_self')
          // window.close()
        })
      }
    },
    openCustService () {
      window.open('https://care60.live800.com/live800/chatClient/chatbox.jsp?companyID=80001804&configID=968&policyId=145&enterurl=csmar&chatfrom=csmar&laiyuan=csmar', '_blank', 'width=900,height=600,top=100px,left=0px')
    }
  }
}
</script>
<style >
.priceListContainer .el-radio__input {
  display: none !important;
}

.priceListContainer .el-radio,
.el-radio__label {
  height: auto !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue